import { createI18n } from 'vue-i18n'

const messages = {
  zh: {
    pageTitle: "沄骐科技",
    nav: {
      home: '首页',
      products: '产品',
      network: '网络',
      news: '公司新闻',
      about: '关于我们'
    },
    home: {
      title: '安全高性能CDN',
      subtitle: '为您提供快速、稳定、安全的CDN服务',
      cta: '立即体验',
      highlights: {
        acceleration: {
          title: '全球加速',
          desc: '覆盖全球的节点网络，为您提供最佳访问体验'
        },
        security: {
          title: '安全防护',
          desc: '多层安全防护，保障您的业务安全'
        },
        scheduling: {
          title: '智能调度',
          desc: '智能缓存、负载均衡和故障转移，确保服务的高效和稳定'
        }
      },
      coverage: {
        title: '覆盖地区',
        subtitle: '我们在全球范围内提供服务，确保最佳性能'
      },
      advantages: {
        title: '产品优势',
        subtitle: '为您提供全方位的CDN解决方案',
        items: {
          realtime: {
            title: '实时缓存',
            desc: '支持实时缓存更新，确保用户始终获取最新的内容，适合需要频繁更新的网站'
          },
          performance: {
            title: '高性能传输',
            desc: '采用先进的边缘计算技术，显著提升内容加载速度和响应时间'
          },
          stability: {
            title: '稳定性强',
            desc: '分布式架构设计具备高度冗余，确保在任何情况下都能保持服务的稳定性和连续性'
          }
        }
      },
      services: {
        title: '主要服务',
        subtitle: '为您提供以下核心服务',
        items: {
          cdn: {
            title: '内容分发网络（CDN）',
            desc: '提供快速可靠的内容传输，优化静态和动态内容加载速度'
          },
          analytics: {
            title: '实时分析',
            desc: '用户可以实时监控流量和性能数据，以便快速响应变化'
          },
          security: {
            title: '应用程序安全',
            desc: '提供 WAF（Web 应用防火墙）、DDoS 防护和其他安全功能，保护应用程序免受攻击'
          },
          edgeComputing: {
            title: '边缘计算',
            desc: '边缘计算Workers是一个功能强大的无服务器计算平台，允许开发者在边缘节点上运行自定义代码'
          }
        }
      },
      socialMedia: {
        wechat: '微信',
        weibo: '微博'
      }
    },
    products: {
      title: '我们的产品',
      subtitle: '探索我们的核心产品和服务',
      items: {
        cdn: {
          icon: '@/assets/images/cdn.svg',
          title: '内容分发网络（CDN）',
          desc: '通过全球分布的边缘节点，减少延迟，提高网站加载速度，特别是在高流量时段。',
          features: [
            '静态和动态内容分发：快速缓存和分发网站的静态资源（如图片、CSS 和 JavaScript）以及动态内容。',
            '实时缓存更新：支持即时更新缓存，确保用户获取最新内容。'
          ]
        },
        edgeComputing: {
          icon: '@/assets/images/edge-computing.svg',
          title: '边缘计算',
          desc: '通过在离用户更近的地方处理请求，边缘计算减少了与传统服务器的距离，从而提高响应速度和降低延迟。',
          features: [
            '边缘计算平台：允许开发者在网络边缘运行代码，处理数据和请求。',
            '无服务器架构：支持无服务器功能，简化开发和部署流程。'
          ]
        },
        imageOptimization: {
          icon: '@/assets/images/image-optimization.svg',
          title: '图像优化',
          desc: '图像优化功能确保用户无论在何种设备上都能获得最佳图像质量，同时提高网站性能。',
          features: [
            '自动格式转换：根据用户的设备自动选择最佳图像格式（如 WebP）。',
            '尺寸调整：根据屏幕大小自动调整图像尺寸，减少加载时间。'
          ]
        },
        waf: {
          icon: '@/assets/images/waf.svg',
          title: 'Web 应用防火墙 (WAF)',
          desc: 'WAF 提供强大的安全保护，防止常见的网络攻击，确保应用程序的安全性和可靠性。',
          features: [
            '实时威胁检测：监控和识别潜在的安全威胁。',
            '自定义规则：允许用户根据需求创建和调整防火墙规则。'
          ]
        },
        ddosProtection: {
          icon: '@/assets/images/ddos.svg',
          title: 'DDoS 防护',
          desc: '通过强大的基础设施，提供高效的 DDoS 防护，确保网站在攻击期间的可用性。',
          features: [
            '流量监测：实时监测异常流量，快速识别 DDoS 攻击。',
            '自动响应：在检测到攻击时自动启动防护措施。'
          ]
        },
        realTimeAnalytics: {
          icon: '@/assets/images/analytics.svg',
          title: '实时分析',
          desc: '实时分析功能使企业能够快速识别流量模式和潜在问题，从而优化用户体验。',
          features: [
            '流量报告：提供实时流量和性能数据，帮助用户了解网站使用情况。',
            '自定义仪表板：用户可以根据需要定制分析视图。'
          ]
        },
        apiAcceleration: {
          icon: '@/assets/images/api-acceleration.svg',
          title: 'API 加速',
          desc: 'API 加速功能确保数据请求快速响应，提升应用程序的整体性能和用户满意度。',
          features: [
            '请求优化：优化 API 请求的传输，减少延迟。',
            '缓存策略：支持不同的缓存策略，以提高 API 性能。'
          ]
        },
        videoStreaming: {
          icon: '@/assets/images/video-streaming.svg',
          title: '视频流媒体',
          desc: '提供稳定的视频流媒体服务，适用于直播和点播内容，确保用户获得无缝的观看体验。',
          features: [
            '高质量流媒体传输：支持 4K 和 HD 视频流的快速传输。',
            '自适应流媒体：根据用户的网络条件自动调整视频质量。'
          ]
        },
        globalLoadBalancing: {
          icon: '@/assets/images/load-balancing.svg',
          title: '全球负载均衡',
          desc: '全球负载均衡功能确保用户始终能够访问最佳的服务节点，提高整体应用的可用性和性能。',
          features: [
            '智能流量分配：根据用户地理位置和实时流量情况智能分配请求。',
            '故障转移：在节点出现故障时自动切换到其他节点，确保服务持续可用。'
          ]
        }
      },
      learnMore: '了解更多'
    },
    network: {
      title: '全球网络',
      subtitle: '覆盖全球的节点分布，为您提供快速稳定的服务',
      stats: {
        nodes: '全球节点',
        countries: '覆盖国家',
        bandwidth: '总带宽',
        availability: '可用性'
      },
      regions: {
        title: '区域分布',
        europe: {
          title: '欧洲',
          desc: '德国、法国、英国等主要城市'
        },
        asia: {
          title: '亚太地区',
          desc: '新加坡、日本、韩国等核心区域'
        },
        america: {
          title: '美洲',
          desc: '美国、加拿大、巴西等主要城市'
        },
        global: {
          title: '全球',
          desc: '覆盖全球的主要城市和地区'
        }
      },
      coverage: {
        title: '覆盖范围',
        subtitle: '我们在全球范围内提供服务，确保最佳性能',
        regions: {
          northAmerica: '北美',
          southAmerica: '南美',
          europe: '欧洲',
          africa: '非洲',
          asia: '亚洲',
          australia: '澳大利亚和新西兰'
        }
      }
    },
    news: {
      title: '公司新闻',
      subtitle: '上海沄骐科技有限公司',
      empty: '暂无新闻',
      card: {
        viewMore: '了解更多'
      },
      newsList: {
        id: 1,
        title: 'Fastly中国总代理重磅官宣！边缘云技术解锁企业出海新速度',
        desc: '当数字化转型进入深水区，"更快响应、更稳安全、更灵部署"已成为企业突围的核心诉求。',
        author: '沄骐科技',
        date: '2025年',
        category: '重磅新闻'
      },
      detail: {
        aboutPartners:'关于合作双方',
        contact: '联系我们',
        phone: '电话',
        email: '邮箱',
        contactText:'“Fastly+企业名称”，前 20 名可免费获取《2025 Fastly攻击威胁洞察报告》+ 1 对 1 方案咨询机会，助力你快速解锁更多Fastly产品价值！'
      },
      newsContent: {
        intro: '当数字化转型进入深水区，"更快响应、更稳安全、更灵部署"已成为企业突围的核心诉求。今天，我们正式宣布：上海沄骐科技有限公司（Miracle Cloud）已经成为全球边缘云领军者Fastly的中国区总代理！Fastly以可编程边缘平台为核心，服务于全球数百家顶尖数字创新企业。此次联手，将给中国出海企业带来怎样的价值，让技术优势转化为业务增长动能？让我们一起跟随沄骐科技的CEO季常青Charlie一起深入探索：',
        section1: '初识 Fastly',
        q1: '能简单介绍一下 Fastly 的核心竞争力吗？',
        a1: '不只是简单的内容分发。Fastly更像是一个 "智能边缘枢纽"，借助Instant Purge即时刷新技术，平均150ms 能在全球即时清除缓存；比同行快32%的首字节到达时间（TTFB）；能实时处理动态内容、API 请求和安全防护。拥有497Tbps的全球边缘网络容量，节点遍布全球6大洲的80+城市。Next-Gen WAF阻断模式、DDoS、Bots机器人管理等安全产品，让企业能精准防控DDoS、机器人及获得保护能力超出OWASP top10里的注入式WEB攻击等形式的威胁。',
        a1_1:'Fastly的核心是',
        a1_2:'可编程边缘云平台',
        q2: '为什么选择引入 Fastly？中国市场最需要它的哪些能力？',
        a2: '首先，主要因为Fastly拥有全球异常丰富的网络容量资源和强大的安全系列产品能更好满足中国客户的现实需求。能精准解决由于全球网络布局不足和复杂网络环境带来的挑战，帮助中国客户分散风险。其次，Fastly 是唯一一家连续七年荣获Gartner Peer Insights "Web应用程序和API保护--客户之选"奖项的供应商。',
        section2: '行业实践',
        q3: 'Fastly在全球服务了众多知名企业，可以和我们分享一个标杆案例吗？',
        a3: 'GitHub 是全球知名的开发者协作平台，拥有 580 万开发者和 1200 万个代码仓库，面临高并发访问、动态内容处理等多重挑战。基于Fastly的自助配置和快速部署的特性，GitHub能在短时间内完成了主站、Pages（网站托管服务）等关键场景的迁移并开始使用。\n\nGitHub 开始使用 Fastly 来构建一个必要的新功能，当他们之前的 CDN 提供商遭遇故障时，他们在一夜之间将剩余的大部分内容迁移到 Fastly 上。由于 Fastly 服务是真正自助式的，并且设置非常快速，GitHub 能够在攻击期间立即切换到 Fastly 并配置其服务，而无需联系销售代表。',
        caseTitle: 'Fastly帮助GitHub的具体应用：',
        caseItem1Title: 'DoS防护',
        caseItem1Desc: 'GitHub 将 Fastly 放在其他经常受到 DoS 攻击的服务前面。利用 Fastly 的宽限模式（grace mode）功能，他们能够通过从缓存中提供过期内容而不是错误信息，来限制攻击对最终用户的影响。',
        caseItem2Title: '动态内容缓存',
        caseItem2Desc: 'GitHub 还使用 Fastly 缓存动态内容，例如 GitHub 仓库中的原始渲染文件。在使用 Fastly 缓存这些文件之前，每当成千上万台机器请求用户生成内容以执行自动化操作时，Raw.GitHub 都会在固定间隔内出现大量请求峰值。',
        caseItem3Title: '源站压力减轻',
        caseItem3Desc: '将 Fastly 放在 Raw 前端后，对同一内容的多个请求会被合并为一个请求，从而显著减少对源站的压力。',
        // 服务支持部分
        supportTitle: '我们提供全流程服务：',
        support1: '网络架构咨询与评估',
        support2: 'CDN部署与优化建议',
        support3: '专属技术培训',
        support4: '故障诊断与快速排查',
        support5: 'SLA级别运维保障',
        section3: '合作落地，展望未来',
        t1:'我们的团队曾服务于',
        t2:'腾讯、网易、Temu、Shein、米哈游、快手、OPPO、华为、荣耀',
        t3:'等海内外知名企业，熟悉大型互联网平台的技术需求与服务标准，具备丰富的行业落地经验。',
        q4: '作为Fastly中国总代理，将为企业提供哪些具体支持？',
        a4: '我们打造专业、优质、诚信的服务体系，谋求与客户共同发展，实现互利共赢。此外技术上，提供定制化方案设计和本地化的技术支持，持续学习与创新，向客户提供行业的前沿技术内容与解决方案建议。\n\n我们拥有一支来自CDN、云计算与网络安全领域的资深技术专家团队，具备丰富的大规模分布式架构经验和企业级服务能力。我们为客户提供全年无休（24/7/365）的专业技术支持服务，通过电话、微信、邮件、飞书等多种渠道，提供全流程服务：',
        supportCompanies: '腾讯、网易、Temu、Shein、米哈游、快手、OPPO、华为、荣耀',
        q5: '最后，对出海企业有什么想说的吗？',
        a5: '数字化转型的核心是 "体验为王"，而 Fastly 就是体验升级的关键引擎。沄骐已准备好为中国出海企业带来定制化方案设计、本地化技术支持、前沿技术赋能，更期待与更多出海企业携手创造新的增长。',
        fastlyDesc: '全球边缘云领域领导者，IDC MarketScape 2024 全球边缘交付服务领导者，连续 7 年获评 Gartner Peer Insights "Web应用程序和API保护--客户之选"奖项的供应商，服务全球数百家顶尖数字创新企业。',
        miracleDesc: '致力于为各行业客户提供全面、快速、稳定、安全的内容分发解决方案，帮助企业在数字化转型的过程中提升业务效率和用户体验。沄骐科技始终秉持“技术驱动，服务至上”的理念，致力于通过创新的技术和优质的服务，推动行业的发展与进步。公司希望成为领先的内容分发和云安全服务提供商，为客户创造更大的价值。',
        contactText: '联系我们： "Fastly+企业名称"，前 20 名可免费获取《2025 Fastly攻击威胁洞察报告》+ 1 对 1 方案咨询机会，助力你快速解锁更多Fastly产品价值！',
        phone: '18601353160',
        email: 'sales@miraclecloudsg.com'
      }
    },
    about: {
      title: '关于我们',
      subtitle: '上海沄骐科技有限公司',
      intro: {
        title: '公司简介',
        content: '上海沄骐科技有限公司是一家专注于内容分发网络（CDN）、云安全等高新技术产品和服务的企业。沄骐科技致力于为各行业客户提供全面、快速、稳定、安全的内容分发解决方案，帮助企业在数字化转型的过程中提升业务效率和用户体验。<br>沄骐科技始终秉持“技术驱动，服务至上”的理念，致力于通过创新的技术和优质的服务，推动行业的发展与进步。公司希望成为领先的内容分发和云安全服务提供商，为客户创造更大的价值。'
      },
      values: {
        title: '企业价值观',
        items: {
          innovation: {
            icon: '创',
            title: '创新',
            desc: '持续技术创新，引领行业发展'
          },
          professional: {
            icon: '专',
            title: '专业',
            desc: '专业的技术团队，优质的服务保障'
          },
          integrity: {
            icon: '诚',
            title: '诚信',
            desc: '诚信经营，客户至上'
          },
          win: {
            icon: '共',
            title: '共赢',
            desc: '与客户共同发展，实现互利共赢'
          }
        }
      },
      contact: {
        title: '联系我们',
        address: {
          title: '地址',
          content: '北京市朝阳区霄云路40号国航世纪大厦3层'
        },
        phone: {
          title: '电话',
          content: '18601353160'
        },
        email: {
          title: '邮箱',
          content: 'sales{\'@\'}miraclecloudsg.com'
        }
      }
    },
    footer: {
      links: {
        title: '快速链接'
      },
      contact: {
        title: '联系我们'
      },
      social: {
        title: '社交媒体'
      },
      copyright: '© 2024 上海沄骐科技有限公司 版权所有'
    }
  },
  en: {
    pageTitle: "MiracleCloud",
    nav: {
      home: 'Home',
      products: 'Products',
      network: 'Network',
      news:'News',
      about: 'About Us'
    },
    home: {
      title: 'Secure High-Performance CDN',
      subtitle: 'Providing fast, stable, and secure CDN services for you',
      cta: 'Try Now',
      highlights: {
        acceleration: {
          title: 'Global Acceleration',
          desc: 'A global network of nodes providing the best access experience'
        },
        security: {
          title: 'Security Protection',
          desc: 'Multi-layer security protection to ensure the safety of your business'
        },
        scheduling: {
          title: 'Smart Scheduling',
          desc: 'Intelligent caching, load balancing, and failover to ensure efficient and stable services'
        }
      },
      coverage: {
        title: 'Coverage Areas',
        subtitle: 'We provide services worldwide to ensure optimal performance'
      },
      advantages: {
        title: 'Product Advantages',
        subtitle: 'Providing comprehensive CDN solutions for you',
        items: {
          realtime: {
            title: 'Real-time Caching',
            desc: 'Supports real-time cache updates to ensure users always get the latest content, suitable for frequently updated websites'
          },
          performance: {
            title: 'High-Performance Transmission',
            desc: 'Utilizes advanced edge computing technology to significantly improve content loading speed and response time'
          },
          stability: {
            title: 'Strong Stability',
            desc: 'Distributed architecture design with high redundancy to ensure service stability and continuity under any circumstances'
          }
        }
      },
      services: {
        title: 'Main Services',
        subtitle: 'Providing the following core services for you',
        items: {
          cdn: {
            title: 'Content Delivery Network (CDN)',
            desc: 'Provides fast and reliable content transmission, optimizing static and dynamic content loading speed'
          },
          analytics: {
            title: 'Real-time Analytics',
            desc: 'Users can monitor traffic and performance data in real-time to quickly respond to changes'
          },
          security: {
            title: 'Application Security',
            desc: 'Offers WAF (Web Application Firewall), DDoS protection, and other security features to protect applications from attacks'
          },
          edgeComputing: {
            title: 'Edge Computing',
            desc: 'Edge Computing Workers is a powerful serverless computing platform that allows developers to run custom code at edge nodes'
          }
        }
      },
      socialMedia: {
        wechat: 'WeChat',
        weibo: 'Weibo'
      }
    },
    products: {
      title: 'Our Products',
      subtitle: 'Explore our core products and services',
      items: {
        cdn: {
          icon: '@/assets/images/cdn.svg',
          title: 'Content Delivery Network (CDN)',
          desc: 'Reduces latency and improves website load speed through globally distributed nodes, especially during high traffic periods.',
          features: [
            'Static and Dynamic Content Delivery: Quickly cache and deliver static resources (like images, CSS, and JavaScript) and dynamic content.',
            'Real-time Cache Updates: Supports instant cache updates to ensure users get the latest content.'
          ]
        },
        edgeComputing: {
          icon: '@/assets/images/edge-computing.svg',
          title: 'Edge Computing',
          desc: 'By processing requests closer to users, edge computing reduces the distance to traditional servers, improving response speed and reducing latency.',
          features: [
            'Edge Computing Platform: Allows developers to run code at the network edge, processing data and requests.',
            'Serverless Architecture: Supports serverless functions, simplifying development and deployment processes.'
          ]
        },
        imageOptimization: {
          icon: '@/assets/images/image-optimization.svg',
          title: 'Image Optimization',
          desc: 'Image optimization ensures users get the best image quality on any device while improving website performance.',
          features: [
            'Automatic Format Conversion: Automatically selects the best image format (like WebP) based on the user\'s device.',
            'Size Adjustment: Automatically adjusts image size based on screen size to reduce load time.'
          ]
        },
        waf: {
          icon: '@/assets/images/waf.svg',
          title: 'Web Application Firewall (WAF)',
          desc: 'WAF provides robust security protection against common web attacks, ensuring application security and reliability.',
          features: [
            'Real-time Threat Detection: Monitors and identifies potential security threats.',
            'Custom Rules: Allows users to create and adjust firewall rules based on their needs.'
          ]
        },
        ddosProtection: {
          icon: '@/assets/images/ddos.svg',
          title: 'DDoS Protection',
          desc: 'Provides efficient DDoS protection through robust infrastructure, ensuring website availability during attacks.',
          features: [
            'Traffic Monitoring: Real-time monitoring of abnormal traffic to quickly identify DDoS attacks.',
            'Automatic Response: Automatically initiates protective measures when an attack is detected.'
          ]
        },
        realTimeAnalytics: {
          icon: '@/assets/images/analytics.svg',
          title: 'Real-time Analytics',
          desc: 'Real-time analytics enable businesses to quickly identify traffic patterns and potential issues, optimizing user experience.',
          features: [
            'Traffic Reports: Provides real-time traffic and performance data to help users understand website usage.',
            'Custom Dashboards: Users can customize analytics views as needed.'
          ]
        },
        apiAcceleration: {
          icon: '@/assets/images/api-acceleration.svg',
          title: 'API Acceleration',
          desc: 'API acceleration ensures fast response to data requests, enhancing overall application performance and user satisfaction.',
          features: [
            'Request Optimization: Optimizes the transmission of API requests to reduce latency.',
            'Caching Strategies: Supports different caching strategies to improve API performance.'
          ]
        },
        videoStreaming: {
          icon: '@/assets/images/video-streaming.svg',
          title: 'Video Streaming',
          desc: 'Provides stable video streaming services for live and on-demand content, ensuring a seamless viewing experience.',
          features: [
            'High-quality Streaming: Supports fast transmission of 4K and HD video streams.',
            'Adaptive Streaming: Automatically adjusts video quality based on user network conditions.'
          ]
        },
        globalLoadBalancing: {
          icon: '@/assets/images/load-balancing.svg',
          title: 'Global Load Balancing',
          desc: 'Global load balancing ensures users always access the best service node, improving overall application availability and performance.',
          features: [
            'Intelligent Traffic Distribution: Distributes requests intelligently based on user location and real-time traffic conditions.',
            'Failover: Automatically switches to other nodes when a node fails, ensuring continuous service availability.'
          ]
        }
      },
      learnMore: 'Learn More'
    },
    network: {
      title: 'Global Network',
      subtitle: 'Global node distribution for fast and stable service',
      stats: {
        nodes: 'Global Nodes',
        countries: 'Countries',
        bandwidth: 'Total Bandwidth',
        availability: 'Availability'
      },
      regions: {
        title: 'Regional Distribution',
        europe: {
          title: 'Europe',
          desc: 'Major cities in Germany, France, and the UK'
        },
        asia: {
          title: 'Asia Pacific',
          desc: 'Core regions including Singapore, Japan, and South Korea'
        },
        america: {
          title: 'America',
          desc: 'Major cities in the US, Canada, Brazil, and more'
        },
        global: {
          title: 'Global',
          desc: 'Coverage in major cities and regions worldwide'
        }
      },
      coverage: {
        title: 'Coverage Areas',
        subtitle: 'We provide services worldwide to ensure optimal performance',
        regions: {
          northAmerica: 'North America',
          southAmerica: 'South America',
          europe: 'Europe',
          africa: 'Africa',
          asia: 'Asia',
          australia: 'Australia & New Zealand'
        }
      }
    },
    news: {
      title: 'Company News',
      subtitle: 'Shanghai Miracle Cloud Technology Co., Ltd.',
      empty: 'No news available',
      card: {
        viewMore: 'Read More'
      },
      newsList: {
        id: 1,
        title: 'Official Announcement: Master Distributor of Fastly in China! Edge Cloud Technology Accelerates Global Business Expansion',
        desc: 'As digital transformation enters the deep-water zone, "faster response, more stable security, and more flexible deployment" have become core requirements for enterprises.',
        author: 'Miracle Cloud',
        date: '2025',
        category: 'Breaking News'
      },
      detail: {
        aboutPartners: 'About the Partners',
        contact: 'Contact Us',
        phone: 'Phone',
        email: 'Email',
        contactText: 'Message "Fastly + Company Name" — the first 20 applicants will receive a free copy of the "2025 Fastly Attack Threat Insight Report" + a 1-on-1 consultation to unlock the full value of Fastly products!'
      },
      newsContent: {
        intro: 'As digital transformation enters the deep-water zone, "faster response, more stable security, and more flexible deployment" have become the core requirements for enterprises to stand out. Today, we officially announce: Shanghai Miracle Cloud Technology (Miracle Cloud) has become the Master Distributor of Fastly, the global leader in edge cloud, for the China region! Fastly serves hundreds of the world’s top digital innovators with its programmable edge platform. What value will this partnership bring to Chinese enterprises going global, and how will it transform technical advantages into business growth? Let’s explore with Charlie Ji, CEO of Miracle Cloud:',
        section1: 'Introduction to Fastly',
        q1: 'Can you briefly introduce Fastly’s core competitiveness?',
        a1_1: 'Fastly’s core is a',
        a1_2: '"Programmable Edge Cloud Platform"',
        a1: 'It is far more than simple content delivery. Fastly acts as an "Intelligent Edge Hub." With its Instant Purge technology, it can clear cache globally in an average of 150ms; its Time to First Byte (TTFB) is 32% faster than competitors. It handles dynamic content, API requests, and security in real-time. With 497Tbps of global edge network capacity, its nodes span 80+ cities across 6 continents. Products like Next-Gen WAF (Blocking Mode), DDoS protection, and Bot Management allow enterprises to precisely defend against DDoS, bots, and injection-based web attacks beyond the OWASP Top 10.',
        q2: 'Why choose to bring Fastly to China? Which capabilities does the China market need most?',
        a2: 'Firstly, Fastly’s exceptionally rich global network capacity and powerful security suite perfectly meet the practical needs of Chinese clients. It solves challenges caused by insufficient global network layouts and complex environments, helping clients mitigate risks. Secondly, Fastly is the only vendor to be named a "Gartner Peer Insights Voice of the Customer for Web Application and API Protection" for seven consecutive years.',
        section2: 'Industry Practices',
        q3: 'Fastly serves many world-renowned companies. Can you share a benchmark case study?',
        a3: 'GitHub is a globally recognized developer collaboration platform with 5.8 million developers and 12 million repositories, facing challenges like high concurrency and dynamic content processing. Thanks to Fastly’s self-service configuration and rapid deployment, GitHub migrated key scenarios like its main site and GitHub Pages in a very short time.\n\nInitially, GitHub used Fastly for a specific new feature. However, when their previous CDN provider experienced an outage, they migrated the majority of their remaining content to Fastly overnight. Since Fastly is truly self-service and incredibly fast to set up, GitHub was able to switch and configure services immediately during the attack without needing to contact a sales representative.',
        caseTitle: 'Specific Applications of Fastly for GitHub:',
        caseItem1Title: 'DoS Protection',
        caseItem1Desc: 'GitHub places Fastly in front of services frequently targeted by DoS attacks. Using Fastly’s "Grace Mode," they limit the impact on end-users by serving stale content from the cache instead of error messages.',
        caseItem2Title: 'Dynamic Content Caching',
        caseItem2Desc: 'GitHub also uses Fastly to cache dynamic content, such as raw rendered files. Previously, Raw.GitHub saw massive request spikes whenever thousands of machines requested user-generated content for automation.',
        caseItem3Title: 'Origin Shielding',
        caseItem3Desc: 'By placing Fastly in front of Raw, multiple requests for the same content are collapsed into a single request, significantly reducing the pressure on origin servers.',
        supportTitle: 'We provide full-process services:',
        support1: 'Network Architecture Consultation & Assessment',
        support2: 'CDN Deployment & Optimization Recommendations',
        support3: 'Exclusive Technical Training',
        support4: 'Fault Diagnosis & Rapid Troubleshooting',
        support5: 'SLA-grade O&M Assurance',
        section3: 'Implementation & Future Outlook',
        t1: 'Our team has served renowned domestic and international enterprises such as',
        t2: 'Tencent, NetEase, Temu, Shein, MiHoYo, Kuaishou, OPPO, Huawei, and Honor',
        t3: '. We are familiar with the technical requirements and service standards of large internet platforms and possess extensive industry implementation experience.',
        q4: 'As Fastly’s Master Distributor in China, what specific support will you provide?',
        a4: 'We aim to build a professional, high-quality, and honest service system to grow together with our clients and achieve win-win results. Technically, we provide customized solution designs and localized technical support, continuously learning and innovating to provide clients with cutting-edge industry content and solution suggestions.\n\nWe have a team of senior technical experts from the CDN, cloud computing, and network security sectors, with rich experience in large-scale distributed architecture. We provide 24/7/365 professional technical support via Phone, WeChat, Email, and Feishu, offering full-process services:',
        supportCompanies: 'Tencent, NetEase, Temu, Shein, MiHoYo, Kuaishou, OPPO, Huawei, Honor',
        q5: 'Finally, do you have a message for Chinese enterprises going global?',
        a5: '"Experience is King" is the core of digital transformation, and Fastly is the key engine for upgrading that experience. Miracle Cloud is ready to bring customized designs, localized support, and cutting-edge empowerment to Chinese enterprises. We look forward to creating new growth together.',
        fastlyDesc: 'A global leader in edge cloud, recognized as a Leader in the 2024 IDC MarketScape for Global Edge Delivery Services. A 7-time recipient of the Gartner Peer Insights "Voice of the Customer" for WAAP, serving hundreds of the world’s top digital innovators.',
        miracleDesc: 'Committed to providing comprehensive, fast, stable, and secure content delivery solutions for clients across various industries, helping enterprises improve business efficiency and user experience during digital transformation. Miracle Cloud adheres to the philosophy of "Technology-Driven, Service-First," striving to become a leading provider of content delivery and cloud security services.',
        contactText: 'Contact us: Message "Fastly + Company Name" — the first 20 applicants will receive a free copy of the "2025 Fastly Attack Threat Insight Report" + a 1-on-1 consultation to unlock the full value of Fastly products!',
        phone: '18601353160',
        email: 'sales@miraclecloudsg.com'
      }
    },
    about: {
      title: 'About Us',
      subtitle: 'Shanghai YunQi Technology Co., Ltd.',
      intro: {
        title: 'Company Profile',
        content: 'Shanghai YunQi Technology Co., Ltd. is a company specializing in high-tech products and services such as content delivery networks (CDN) and cloud security. YunQi Technology is dedicated to providing comprehensive, fast, stable, and secure content delivery solutions for clients across various industries, helping businesses to improve operational efficiency and user experience during their digital transformation.<br> YunQi Technology has always adhered to the concept of "technology-driven, service-oriented," striving to drive industry development and progress through innovative technology and high-quality services. The company aims to become a leading provider of content delivery and cloud security services, creating greater value for customers.'
      },
      values: {
        title: 'Corporate Values',
        items: {
          innovation: {
            icon: 'IN',
            title: 'Innovation',
            desc: 'Continuous technological innovation, leading industry development'
          },
          professional: {
            icon: 'PR',
            title: 'Professional',
            desc: 'Professional technical team, quality service guarantee'
          },
          integrity: {
            icon: 'IN',
            title: 'Integrity',
            desc: 'Honest operation, customer first'
          },
          win: {
            icon: 'WW',
            title: 'Win-Win',
            desc: 'Develop with customers, achieve mutual benefits'
          }
        }
      },
      contact: {
        title: 'Contact Us',
        address: {
          title: 'Address',
          content: '3rd Floor, Air China Century Building, 40 Xiaoyun Road, Chaoyang District, Beijing'
        },
        phone: {
          title: 'Phone',
          content: '18601353160'
        },
        email: {
          title: 'Email',
          content: 'sales{\'@\'}miraclecloudsg.com'
        }
      }
    },
    footer: {
      links: {
        title: 'Quick Links'
      },
      contact: {
        title: 'Contact Us'
      },
      social: {
        title: 'Social Media'
      },
      copyright: '© 2024 Shanghai YunQi Technology Co., Ltd. All rights reserved'
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'zh',
  fallbackLocale: 'en',
  messages,
})

export default i18n 